import { map, mergeMap, catchError, tap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { studentGoalsService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as actions from './actions';
import { of } from 'rxjs';
import { NotificationManager } from 'react-notifications';

export function getStudentGoals(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_STUDENT_GOALS),
    mergeMap(({ payload }) => {
      return studentGoalsService.getStudentGoals(payload).pipe(
        map((res) => actions.getStudentGoalsSuccess(res)),
        catchError((error) =>
          of({
            type: actionTypes.GET_STUDENT_GOALS_FAIL,
            payload: error,
            error: true
          })
          // console.log("error...........")
        )
      )
    })
  )
}

export function saveStudentGoals(action$) {
  return action$.pipe(
    ofType(actionTypes.SAVE_STUDENT_GOALS),
    mergeMap(({ payload }) => {
      return studentGoalsService.saveStudentGoals(payload).pipe(
        map((res) => actions.saveStudentGoalsSuccess(res)),
        catchError((error) =>
          of({
            type: actionTypes.SAVE_STUDENT_GOALS_FAIL,
            payload: error,
            error: true
          })
          // console.log("error...........")
        )
      )
    })
  )
}

export function getStudentGoalsAndDownload(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_STUDENT_GOALS_DOWNLOAD),
    mergeMap(({ payload }) => {
      return studentGoalsService.getStudentGoals(payload).pipe(
        tap(res => {
          if (res.responceObject.records.pre_signed_URL) {
            // call edumate api to download academic report pdf
            const anchor = document.createElement('a');
            anchor.setAttribute('href', res.responceObject.records.pre_signed_URL);
            anchor.setAttribute('target', '_blank');
            anchor.setAttribute('download', 'PLC_Student_Goals_CSV' + '.csv');
            anchor.click();
            anchor.remove();
            NotificationManager.success(
              'Success message',
              'Check Your Downloads.'
            );
          }
        }),
        map((res) => {
          return actions.getStudentGoalsSuccess(res)
        }),
        catchError((error) =>
          of({
            type: actionTypes.GET_STUDENT_GOALS_FAIL,
            payload: error,
            error: true
          })
          // console.log("error...........")
        )
      )
    })
  )
}

